'use strict';

function DataRetrieverSearchRulesTransformerService(dataRetrieverDateMergerService) {
  return {
    mergeDateRules: dataRetrieverDateMergerService.merge
  };
}
DataRetrieverSearchRulesTransformerService.$inject = ['DataRetrieverDateMergerService'];
module.exports = DataRetrieverSearchRulesTransformerService;